import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Toaster } from '@/components/ui/toaster'
import { Toaster as Sonner } from '@/components/ui/sonner'
import { TooltipProvider } from '@/components/ui/tooltip'
import { AuthProvider } from '@/hooks/use-auth'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { AuthRoute } from '@/components/AuthRoute'
import { ThemeProvider } from '@/components/ThemeProvider'
import Layout from './components/Layout'
import Index from './pages/Index'
import SignupPage from './pages/Signup'
import LoginPage from './pages/Login'
import DashboardPage from './pages/Dashboard'
import SubscribePage from './pages/Subscribe'
import SubscriptionManagementPage from './pages/SubscriptionManagement'
import NotFound from './pages/NotFound'

const App = () => (
  <BrowserRouter>
    <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
      <AuthProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Index />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/login" element={<LoginPage />} />

              <Route element={<ProtectedRoute />}>
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route
                  path="/subscription-management"
                  element={<SubscriptionManagementPage />}
                />
              </Route>

              <Route element={<AuthRoute />}>
                <Route path="/subscribe" element={<SubscribePage />} />
              </Route>
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </TooltipProvider>
      </AuthProvider>
    </ThemeProvider>
  </BrowserRouter>
)

export default App
